<div style="padding: 15px; background-color: #fafafa; margin-top: 64px; height: 100%;">
    @if (Url != '/unavailable') {
    <div>
        {{Message}}
    </div>
    }

    @if (Url == '/unavailable') {
    <div class="unavailable-container">
        <div class="unavailable">
            <p>
                From <strong>7pm on Wednesday, October 21st</strong> to <strong>6am on Monday, October 26th</strong> OMB Collect will be offline for scheduled maintenance.
                <br />
                If you are receiving this message outside that timeframe, please contact <a href="mailto:maxsupport@max.gov">maxsupport&#64;max.gov</a>.
            </p>
            <br />
            <p>
                Thank you,<br />
                The OMB Collect Team
            </p>
        </div>
    </div>
    }
</div>
